import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { 
  LayoutDashboard, PieChart, ShoppingCart, DollarSign, Users, 
  Store, PackageSearch, FileText, Bell, User, LogOut, Activity
} from 'lucide-react';
import { useUser } from '../../context/UserContext';
import { useNavigate } from 'react-router-dom';

const PartnerSidebar = () => {
  const { logout } = useUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/account');
  };

  return (
    <aside className="partner-sidebar">
      <Link to="/partner/dashboard" className="px-4 py-4 border-bottom border-secondary d-flex align-items-center gap-2 text-white">
        <div className="rounded d-flex align-items-center justify-content-center" style={{ width: 32, height: 32, background: 'var(--partner-accent)' }}>
          <Activity size={18} />
        </div>
        <span className="fw-bold" style={{ fontSize: '1.2rem', letterSpacing: '-0.5px' }}>Partner BI</span>
      </Link>

      <nav className="partner-nav custom-scrollbar">
        <div className="text-secondary text-uppercase fw-bold mt-2" style={{ fontSize: '0.65rem', padding: '0 1rem', marginBottom: '0.5rem', letterSpacing: '0.5px' }}>
          Overview
        </div>
        
        <NavLink to="/partner/dashboard" end className={({ isActive }) => `partner-link ${isActive ? 'active' : ''}`}>
          <LayoutDashboard size={18} />
          <span>Dashboard</span>
        </NavLink>
        
        <NavLink to="/partner/analytics" className={({ isActive }) => `partner-link ${isActive ? 'active' : ''}`}>
          <PieChart size={18} />
          <span>Analytics</span>
        </NavLink>
        
        <div className="text-secondary text-uppercase fw-bold mt-4" style={{ fontSize: '0.65rem', padding: '0 1rem', marginBottom: '0.5rem', letterSpacing: '0.5px' }}>
          Core Metrics
        </div>

        <NavLink to="/partner/orders" className={({ isActive }) => `partner-link ${isActive ? 'active' : ''}`}>
          <ShoppingCart size={18} />
          <span>Orders Overview</span>
        </NavLink>
        
        <NavLink to="/partner/revenue" className={({ isActive }) => `partner-link ${isActive ? 'active' : ''}`}>
          <DollarSign size={18} />
          <span>Revenue Insights</span>
        </NavLink>

        <NavLink to="/partner/users" className={({ isActive }) => `partner-link ${isActive ? 'active' : ''}`}>
          <Users size={18} />
          <span>Users / Traffic</span>
        </NavLink>
        
        <NavLink to="/partner/sellers" className={({ isActive }) => `partner-link ${isActive ? 'active' : ''}`}>
          <Store size={18} />
          <span>Sellers Overview</span>
        </NavLink>

        <NavLink to="/partner/products" className={({ isActive }) => `partner-link ${isActive ? 'active' : ''}`}>
          <PackageSearch size={18} />
          <span>Products</span>
        </NavLink>

        <div className="text-secondary text-uppercase fw-bold mt-4" style={{ fontSize: '0.65rem', padding: '0 1rem', marginBottom: '0.5rem', letterSpacing: '0.5px' }}>
          Tools
        </div>

        <NavLink to="/partner/reports" className={({ isActive }) => `partner-link ${isActive ? 'active' : ''}`}>
          <FileText size={18} />
          <span>Reports</span>
        </NavLink>

        <NavLink to="/partner/notifications" className={({ isActive }) => `partner-link ${isActive ? 'active' : ''}`}>
          <Bell size={18} />
          <span>Notifications</span>
        </NavLink>

        <NavLink to="/partner/profile" className={({ isActive }) => `partner-link ${isActive ? 'active' : ''}`}>
          <User size={18} />
          <span>Profile</span>
        </NavLink>

        <div className="mt-auto pt-3 pb-2 w-100">
          <button className="partner-link w-100 bg-transparent border-0 text-start text-danger" onClick={handleLogout}>
            <LogOut size={18} />
            <span className="fw-bold">Logout</span>
          </button>
        </div>
      </nav>
    </aside>
  );
};

export default PartnerSidebar;
